import { RootState } from "../store";

export const selectInsuredOptions = (state: RootState) => state.insured.insuredOptions;
export const selectErrorMessageInsured = (state: RootState) => state.insured.errorMessage;
